/* istanbul ignore file */
import { createSelector } from 'reselect';
import { getSelector } from 'redux/selectors';

export const accessTokenSelector =
  createSelector(getSelector('auth', 'tokenInfo'), state => state.getIn(['data', 'accessToken']));

export const currentMemberSelector =
  createSelector(getSelector('auth', 'tokenInfo'), state => state.getIn(['data', 'member']));

export const currentUserRoleSelector =
  createSelector(getSelector('auth', 'tokenInfo'), state => state.getIn(['data', 'user', 'role', 'name']));

export const currentUserSelector =
  createSelector(getSelector('auth', 'tokenInfo'), state => state.getIn(['data', 'user']));

export const currentUserProfileSelector =
  createSelector(getSelector('auth', 'tokenInfo'), state => state.getIn(['data', 'user', 'account', 'profile']));
